import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {connect} from "react-redux";
import {fetchBusinessById} from "../state/actions/business";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import BusinessHeader from '../parts/BusinessHeader';
import BusinessTestimonial from '../parts/BusinessTestimonial';
import BusinessEndCallToAction from '../parts/BusinessEndCallToAction';
import Footer from '../parts/Footer';

import heroBackgroundImage from '../assets/images/background-restaurant-hero.jpg';
import iPhoneYourShifts from '../assets/images/iphone-your-shifts.png';
import bizCollageImage from '../assets/images/biz-collage.jpg';
import manHoldingSandwhichImage from '../assets/images/man-holding-sandwhich.jpg';
import iconCheck from '../assets/images/icon-check.png';
import iconStep1 from '../assets/images/icon-qualified-pro.png';
import iconStep2 from '../assets/images/icon-on-demand.png';
import iconStep3 from '../assets/images/icon-receipt.png';


export class RestaurantHomePage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "Restaurants");

    // Check if the user is "logged in"
    const businessId = localStorage.getItem('businessId');
    if (businessId) {
      this.props.fetchBusinessById(businessId);
    }
  }

  getStartedClicked = () => {
    if (this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    window.prerenderReady = true;
    const {classes} = this.props;

    return (
      <div className="business home">
        <Helmet>
          {title('SingleShift - Restaurants')}
          {metaTitles('SingleShift - Restaurants')}
          {metaDescriptions('Book online in minutes and schedule a Pro for whenever you need them in the next day or week.')}
          {metaImages(`${window.location.origin}${heroBackgroundImage}`)}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* HERO */}
        <div className="hero" style={{backgroundImage: `url(${heroBackgroundImage})`}}>
          <div className="container">
            <BusinessHeader/>
            <div className="row flex-md-row-reverse align-items-center">
              <div className="col-md-6 headline">
                <h1>Never be short staffed again.</h1>
                <p>Book online in minutes and schedule a Pro for whenever you need them.</p>
                <button onClick={this.getStartedClicked} type="button" className={`${classes.heroBtn} btn btn-primary btn-xlg btn-pointer`}>Get Started</button>
              </div>
              <div className="col-md-6 text-center iphone">
                <img className="img-fluid" src={iPhoneYourShifts}/>
              </div>
            </div>
          </div>
        </div>

        {/* HOW IT WORKS */}
        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h2 className={classes.sectionHeadlineWithDescription}>Flexible staffing for restaurants.</h2>
                <p className="text-demphasis">Get your shifts filled with reliable and prequalified dishwashers, cooks, servers, and more, without any hassle.</p>
                <div className={classes.steps}>
                  <h3 className={classes.stepsHeadline}>1. Post a shift</h3>
                  <p className="text-demphasis">Book a shift through our website and we’ll find someone great from our pool of prequalified workers.</p>
                </div>
                <div className={classes.steps}>
                  <h3 className={classes.stepsHeadline}>2. We send you a Pro</h3>
                  <p className="text-demphasis">Once someone is matched to your shift you’ll get notified. Your worker will show up on the time you request.</p>
                </div>
                <div className={classes.steps}>
                  <h3 className={classes.stepsHeadline}>3. We handle the billing and logistics</h3>
                  <p className="text-demphasis">After the shift, we handle all the billing and logistics so you can spend more time running your business.</p>
                </div>
              </div>
              <div className="col-md-6">
                <img className="img-fluid" src={bizCollageImage} />
              </div>
            </div>
          </div>
        </div>

        {/* AVAILABLE */}
        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <img className="img-fluid" src={manHoldingSandwhichImage} />
              </div>
              <div className="col-md-6">
                <h2 className={classes.sectionHeadline}>Available when you need them the most.</h2>
                <ul className="list-unstyled">
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}>Add staff for busy weekends or events</p>
                  </li>
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}>Stand-ins for last minate call-offs or no-shows</p>
                  </li>
                  <li className={classes.builtForItem}>
                    <img className={classes.builtForItemImage} src={iconCheck}/>
                    <p className={classes.builtforItemCopy}>Cover employee vacations and vacancies</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/*  TAKE THE WORRY OUT OF STAFFING */}
        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className={`${classes.sectionHeader} text-center`}>Take the worry out of staffing.</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 text-center">
                <img className={classes.howItWorksImage} src={iconStep1}/>
                <h4 className={classes.howItWorksItem}>Qualified professionals</h4>
                <p className="text-demphasis">Enter the details of your shift and set what you're willing to pay.</p>
              </div>
              <div className="col-md-4 text-center">
                <img className={classes.howItWorksImage} src={iconStep2}/>
                <h4 className={classes.howItWorksItem}>On-demand availability</h4>
                <p className="text-demphasis">Enter the details of your shift and set what you're willing to pay.</p>
              </div>
              <div className="col-md-4 text-center">
                <img className={classes.howItWorksImage} src={iconStep3}/>
                <h4 className={classes.howItWorksItem}>Hassle free pricing</h4>
                <p className="text-demphasis">Enter the details of your shift and set what you're willing to pay.</p>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <BusinessTestimonial/>
        </div>

        <BusinessEndCallToAction/>

        <Footer/>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
});

const styles = (theme) => ({
  heroBtn: {
    marginBottom: '15px',
  },
  section: {
    padding: '100px 0',
    borderBottom: '1px solid #efefef',
  },
  sectionHeader: {
    paddingBottom: 30,
  },
  sectionHeadline: {
    marginBottom: 30,
  },
  sectionHeadlineWithDescription: {
    marginBottom: 0,
  },
  steps: {
    marginTop: '30px',
  },
  stepsHeadline: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '30px',
    marginBottom: 5,
  },
  builtForItem: {
    overflow: 'hidden',
  },
  builtForItemImage: {
    float: 'left',
    width: '35px',
  },
  builtforItemCopy: {
    marginLeft: '45px',
  },
  howItWorksItem: {
    fontSize: '20px',
    lineHeight: '30px',
    margin: '10px 0 5px',
    fontWeight: 'bold',
  },
  howItWorksImage: {
    width: '100px',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RestaurantHomePage));



// WEBPACK FOOTER //
// ./src/pages/RestaurantHomePage.js